import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import GiftImage from "../Images/GiftImage.png";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import leftchevron from "../Images/leftchevron.png";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";

export default function OrderDetials() {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const steps = [
    t("profileOrderHistory.ordered"),
    t("profileOrderHistory.withdeliveryman"),
    t("profileOrderHistory.delivered"),
  ];
  useEffect(() => {
    const normalizedPath = window.location.pathname.toLowerCase();
    if (window.location.pathname !== normalizedPath) {
      history.replace(normalizedPath); // Redirect to lowercase URL
    }
  }, [history]);

  const handleDivClick = (CategoryName) => {
    history.push(`/profile/history-order`);
  };
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [TheOrder, setTheOrder] = useState({});
  const [Loading, setLoading] = useState(true);

  const { theorder } = useParams(); // Extracts the ID from the URL
  const user = JSON.parse(localStorage.getItem("user"));

  // const location = useLocation();
  // const { TheOrder } = location.state;

  const fetchData = async () => {
    const data = {
      Id: theorder,
      UserId: user?.userId,
    };
    try {
      const response = await axios.post(`${MyDomain}Orders/GetUserOrder`, data);
      setTheOrder(response.data[0]);
      setLoading(false);
    } catch (err) {
      setLoading(true);
      console.log(err.response.data);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (Loading) return <a>loading...</a>;
  const totalPrice = TheOrder.products.reduce(
    (sum, item) => sum + item.priceBeforeDiscount,
    0
  );

  const totalPrice2 = TheOrder.products.reduce(
    (sum, item) => sum + item.priceAfterDiscount,
    0
  );
  return (
    <div
      style={{
        paddingTop: 50,
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: MyWidth <= 1024 ? "column" : "row",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: MyWidth <= 1024 ? "column" : "row",
            //backgroundColor: "green",
            width: MyWidth <= 1024 ? "100%" : "60%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingRight: 20,
              maxWidth: MyWidth <= 1024 ? "100%" : "50%",
              //backgroundColor: "red",
            }}
          >
            {MyWidth <= 1024 ? (
              <img
                src={leftchevron}
                style={{
                  width: 18,
                  height: 18,
                  cursor: "pointer",
                  margin: 0,
                  opacity: 0.5,
                  marginBottom: 10,
                  //opacity: currentSlide === 0 ? 0.3 : 1,
                  //cursor: currentSlide === 0 ? "" : "pointer",
                }}
                onClick={() => {
                  handleDivClick();
                }}
              />
            ) : (
              <></>
            )}

            <a style={{ fontSize: 18, fontWeight: 600 }}>
              {t("profileOrderHistory.Orderdetails")}:
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Orderid")}:{" "}
              <a
                style={{
                  backgroundColor: "#e5e5e5",
                  paddingLeft: 5,
                  paddingRight: 5,
                }}
              >
                {TheOrder.order.id}
              </a>
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Totalprice")}: ₪{TheOrder.order.price}
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Dateorder")}: {TheOrder.order.dateOrder}
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Timeorder")}: {TheOrder.order.timeOrder}
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.paymenttype")}:{" "}
              {TheOrder.order.paymentType === 1 ? (
                <>{t("profile.Cash")}</>
              ) : (
                <>{t("profile.CreditCard")}</>
              )}
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.comment")}: {TheOrder.order.comment}
            </a>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 20,
              //backgroundColor: "gray",
              paddingRight: 20,
            }}
          >
            <a style={{ fontSize: 18, fontWeight: 600 }}>
              {t("profileOrderHistory.Addressdetails")}:-
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Fullname")}:{" "}
              {TheOrder.addresses.firstName} {TheOrder.addresses.lastName}
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Phonenumber")}:{" "}
              {TheOrder.addresses.phonenumber}
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.city")}: {TheOrder.addresses.city}
            </a>
            {/* <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Street")}: {TheOrder.addresses.street}
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Building")}: {TheOrder.addresses.building}
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Apartment")}:{" "}
              {TheOrder.addresses.apartment}
            </a>
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.ZIPcode")}: {TheOrder.addresses.zipCode}
            </a> */}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 20,
              //backgroundColor: "gray",
            }}
          >
            <a>
              {TheOrder.promoCode === null ? (
                <></>
              ) : (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <a style={{ fontSize: 18, fontWeight: 600 }}>
                    {t("profileOrderHistory.couponcode")}:-{" "}
                  </a>
                  <a style={{ fontSize: 14 }}>
                    {t("profileOrderHistory.Codeused")}:{" "}
                    {TheOrder.promoCode.name}
                  </a>
                  <a style={{ fontSize: 14 }}>
                    {t("profileOrderHistory.Discount")}:{" "}
                    <a
                      style={{
                        backgroundColor: "#7e22ce",
                        paddingLeft: 5,
                        paddingRight: 5,
                        color: "white",
                      }}
                    >
                      {TheOrder.promoCode.discount}%
                    </a>
                  </a>
                </div>
              )}
            </a>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            //backgroundColor: "#bbf7d0",
            width: MyWidth <= 1024 ? "100%" : "40%",
            maxHeight: 350,
            overflowY: "auto", // Enable vertical scrolling when content overflows
            border: "0.1px solid #e4e4e7",
          }}
        >
          {TheOrder.products.map((product, index) => (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  //justifyContent: "center",
                  paddingBottom: 20,
                }}
              >
                <img
                  src={product.image}
                  style={{
                    width: "25%",
                    height: "auto",
                    margin: 0,
                  }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <a style={{ fontSize: 14, paddingBottom: 5 }}>
                    {t("profile.productID")}
                    <a
                      style={{
                        backgroundColor: "#e5e5e5",
                        paddingLeft: 5,
                        paddingRight: 5,
                      }}
                    >
                      {product.idOfProduct}
                    </a>
                  </a>
                  <a style={{ fontSize: 14, opacity: 0.5 }}>{product.name}</a>
                  <a style={{ fontSize: 14, opacity: 0.5, paddingBottom: 5 }}>
                    {product.productType}
                  </a>
                  <a style={{ fontSize: 14 }}>
                    {product.isGift === 2 ? (
                      <>
                        <img
                          src={GiftImage}
                          style={{
                            width: 18,
                            height: 18,
                          }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                    {product.isGift === 2 ? (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <a style={{ fontSize: 14 }}>
                          <a
                            style={{
                              backgroundColor: "#7e22ce",
                              paddingLeft: 5,
                              paddingRight: 5,
                              color: "white",
                            }}
                          >
                            {t("profileOrderHistory.Free")}
                          </a>
                        </a>
                      </div>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        {product.discount !== 0 ? (
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <a style={{ fontSize: 14, color: "red" }}>
                              ₪{product.priceAfterDiscount}
                            </a>
                            &nbsp; &nbsp;
                            <a
                              style={{
                                fontSize: 14,
                                textDecoration: "line-through",
                              }}
                            >
                              ₪{product.priceBeforeDiscount}
                            </a>
                            &nbsp; &nbsp;
                            <a
                              style={{
                                fontSize: 14,
                                backgroundColor: "#7e22ce",
                                paddingLeft: 5,
                                paddingRight: 5,
                                color: "white",
                              }}
                            >
                              {product.discount}%
                            </a>
                          </div>
                        ) : (
                          <>
                            <a style={{ fontSize: 14 }}>
                              {t("profileOrderHistory.Price")}: ₪
                              {product.priceAfterDiscount}
                            </a>
                          </>
                        )}
                      </div>
                    )}
                  </a>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div
                  style={{
                    height: "0.1px",
                    backgroundColor: "#f4f4f5",
                    width: "90%",
                    //marginBottom: 40,
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          flexDirection: MyWidth <= 1024 ? "column" : "row",
        }}
      >
        {MyWidth <= 1024 ? (
          <></>
        ) : (
          <div
            style={{
              display: "flex",
              width: MyWidth <= 1024 ? "100%" : "60%",
              direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Stepper activeStep={TheOrder.order.orderStatus} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </div>
        )}

        <div
          style={{
            display: "flex",
            width: MyWidth <= 1024 ? "100%" : "40%",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "90%",
            }}
          >
            <a style={{ fontSize: 14 }}>
              {t("profileOrderHistory.Pricebeforediscounts")}:{" "}
            </a>
            <a style={{}}>₪{totalPrice}</a>
          </div>
          {TheOrder.promoCode === null ? (
            <></>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "90%",
              }}
            >
              <a style={{ fontSize: 14 }}>
                {t("profileOrderHistory.PricebeforePromocodeDiscount")}:{" "}
              </a>
              <a style={{}}>₪{totalPrice2}</a>
            </div>
          )}

          {TheOrder.promoCode === null ? (
            <></>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "90%",
                }}
              >
                <a style={{ fontSize: 14 }}>
                  {t("profileOrderHistory.Discountcouponcode")}:{" "}
                </a>
                <a
                  style={{
                    fontSize: 14,
                    backgroundColor: "#7e22ce",
                    paddingLeft: 5,
                    paddingRight: 5,
                    color: "white",
                  }}
                >
                  {TheOrder.promoCode.discount}%
                </a>
              </div>
            </>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "90%",
            }}
          >
            <a style={{ fontSize: 14 }}>{t("profileOrderHistory.delivery")}</a>
            <a>
              {totalPrice <= 200 ? (
                <>
                  <a>₪20</a>
                </>
              ) : (
                <>
                  <a>₪0</a>
                </>
              )}
            </a>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "90%",
              paddingTop: 20,
            }}
          >
            <a style={{ fontSize: 18, fontWeight: 500 }}>
              {t("profileOrderHistory.GrandTotal")}:
            </a>
            <a
              style={{
                fontSize: 18,
                //backgroundColor: "#e5e5e5",

                fontWeight: 500,
              }}
            >
              ₪{TheOrder.order.price}
            </a>
          </div>
          {TheOrder.order.price <= totalPrice ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "90%",
              }}
            >
              <a style={{ fontSize: 14 }}>
                {t("profileOrderHistory.yousaved")}:{" "}
              </a>
              <a style={{ color: "#16a34a", fontWeight: 500 }}>
                ₪{(totalPrice - TheOrder.order.price).toFixed(2)}
              </a>
            </div>
          ) : (
            <></>
          )}
        </div>
        {MyWidth <= 1024 ? (
          <div
            style={{
              display: "flex",
              width: MyWidth <= 1024 ? "100%" : "60%",
              paddingTop: 50,
              direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Stepper activeStep={TheOrder.order.orderStatus} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
